import { CashMovementType } from 'api';

export const mapStatusToPlusMinusType: Partial<Record<CashMovementType, '+' | '-' | ''>> = {
  [CashMovementType.CashOutOfPortfolio]: '-',
  [CashMovementType.CashInToPortfolio]: '+',
  [CashMovementType.BankToBank]: '',
  [CashMovementType.FundToInvestor]: '-',
  [CashMovementType.InvestorToFund]: '+',
};
